// Работа с DOM и урлами.

function parseUrlParams(source) {
    const pairs = source.split("&");
    const params = {};
    pairs.forEach(pairStr => {
        const pair = pairStr.split("=");
        params[pair[0]] = decodeURIComponent(pair[1]);
    });
    return params;
}

function LocationParams() {
    if (window.URLSearchParams) {
        return new URLSearchParams(window.location.search.substring(1));
    }
    this.params = parseUrlParams();
    return this;
}

LocationParams.prototype.has = function (name) {
    return this.params.hasOwnProperty(name);
};

LocationParams.prototype.get = function (name) {
    return this.params[name] || null;
};

function callAfterLoaded(func) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            func();
        });
    } else {
        func();
    }
}

function callAfterWindowLoaded(func) {
    if (document.readyState === "complete") {
        func();
    } else {
        window.addEventListener("load", () => {
            func();
        });
    }
}

function hide(elem) {
    elem.style.display = "none";
}

function show(elem) {
    elem.style.display = "";
}

// isImageLoaded проверяет, что картинка была загружена
function isImageLoaded(img) {
    return img.complete;
}

function isElementVisible(element, offsetGap = 0) {
    const bodyHeight = window.innerHeight;
    const offset = element.getBoundingClientRect().top;
    return offset > 0 && offset < (bodyHeight - parseInt(offsetGap, 10));
}

function scrollToElement(element, gap = 0) {
    const elementTopOffset = element.offsetTop;
    window.scrollTo({
        top: elementTopOffset - gap,
        behavior: "smooth",
    });
}

const locationParams = new LocationParams();

function callOnIntersecting(element, callback, threshold = 1, onlyOnce = true) {
    if (!("IntersectionObserver" in window)) {
        callback();
        return;
    }

    function handleIntersection(entries, observer) {
        const entry = entries[0];
        callback(entry.isIntersecting);
        if (entry.isIntersecting && onlyOnce) {
            observer.unobserve(element);
        }
    }

    const observer = new IntersectionObserver(handleIntersection, { threshold: [threshold] });
    observer.observe(element);
}

export default {
    locationParams,
    callAfterLoaded,
    callAfterWindowLoaded,
    hide,
    show,
    isImageLoaded,
    isElementVisible,
    scrollToElement,
    callOnIntersecting,
};
